import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr auto;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledName = styled(Text)`
	font-size: 16px;
	color: rgba(255, 255, 255, 0.75);
`;

const StyledCount = styled(Text)`
	font-weight: 500;
	font-size: 16px;
	color: #ffffff;

	span {
		font-size: 14px;
		font-weight: 400;
		opacity: 0.5;
	}
`;

export { StyledContainer, StyledName, StyledCount };
